<template>
    <div class="stagedetail_page">
        <div class="stagedetail_page_top">
            <div class="top_label">
                <span class="lable_name">分层教学</span>
                <span class="lable_title">{{form.trem}}期{{form.level}}层 | {{title}}</span>
            </div>
            <el-button @click="$router.back(-1)" type="text" icon="el-icon-arrow-left" size="medium">返回</el-button>
        </div>
        

        <div class="stagedetail_statitsc">
            <div class="stagedetail_statitsc_item">
                <div class="stagedetail_statitsc_item_content">
                    <span class="title">题型总题量</span>
                    <div class="statistics_number">
                        <span class="number">{{topStatistics.total_number}}</span>
                        <span class="unit">篇</span>
                    </div>
                    
                </div>
                <div class="stagedetail_statitsc_item_right">
                    <span class="stagedetail_statitsc_item_content_icon">
                        <i class="el-icon-message-solid"></i>
                    </span>
                </div>
            </div>
            <div class="stagedetail_statitsc_item">
                <div class="stagedetail_statitsc_item_content">
                    <span class="title">已做题</span>
                    <div class="statistics_number">
                        <span class="number">{{topStatistics.do_number}}</span>
                        <span class="unit">篇</span>
                    </div>
                </div>
                <div class="stagedetail_statitsc_item_right">
                    <span style="color: #F56C6C;background: #FDE2E2;" class="stagedetail_statitsc_item_content_icon">
                        <i class="el-icon-edit"></i>
                    </span>
                </div>
            </div>
            <div class="stagedetail_statitsc_item">
                <div class="stagedetail_statitsc_item_content">
                    <span class="title">平均正确率</span>
                    <div class="statistics_number">
                        <span class="number">{{topStatistics.avg_score}}</span>
                        <span class="unit">%</span>
                    </div>
                </div>
                <div class="stagedetail_statitsc_item_right">
                    <span style="color: #9333ea;background: #f3e8ff;" class="stagedetail_statitsc_item_content_icon">
                        <i class="el-icon-s-data"></i>
                    </span>
                </div>
            </div>
            <div class="stagedetail_statitsc_item">
                <div class="stagedetail_statitsc_item_content">
                    <span class="title">学习时长</span>
                    <span class="number">{{topStatistics.total_time}}</span>
                </div>
                <div class="stagedetail_statitsc_item_right">
                    <span style="color: #67C23A;background: #E1F3D8;" class="stagedetail_statitsc_item_content_icon">
                        <i class="el-icon-medal"></i>
                    </span>
                </div>
            </div>
        </div>
        <div style="margin-top:20px" class="top_label_namebox">
            <i class="el-icon-edit"></i>
            <span class="lable_name">试题列表</span>
        </div>
        
        <div class="stagedetail_work">
            <div v-for="item in gridData" :key="item.id" class="stagedetail_work_item">
                <div class="stagedetail_work_item_title_box">
                    <span class="title">{{item.title}}</span>
                    <span v-if="item.is_do" class="score">{{item.score}}%</span>
                </div>
                
                <div class="tag_box">
                    <el-tag>{{item.type_text}}</el-tag>
                    <el-tag>{{item.level}} 层</el-tag>
                    <el-tag type="danger">{{item.frequency}}次</el-tag>
                </div>
                <div style="display: flex; align-items: flex-end; justify-content: flex-end; width: 100%;">
                    <div @click="handleEdit(item)" v-if="!item.is_do" class="do_work">
                        <span>做题</span>
                        <i class="el-icon-right"></i>
                    </div>
                    <div @click="handleEdit(item)" v-else class="do_work" style="color:#f56c6c;background:#fde2e2">
                        <span>查看</span>
                        <i class="el-icon-right"></i>
                    </div>
                </div>

            </div>
        </div>
        <div class="pagination_box">
            <el-pagination
                background
                layout="prev, pager, next"
                @size-change="changeSize"
                @current-change="changeNumber"
                @prev-click="prev"
                @next-click="next"
                :page-size="form.pageSize"
                hide-on-single-page
                :total="total_number">
            </el-pagination>
        </div>
        


    </div>
</template>
<script>
import Http from "../../apis/student";
export default {
    data() {
        return {
            title: this.$route.query.title,
            type: this.$route.query.type,
            form:{
                level:this.$route.query.level,
                grade:this.$route.query.grade,
                trem:this.$route.query.trem,
                type:this.$route.query.type,
                page:1,
                pageSize:20,
            },
            gridData: [],
            total_number: 0,
            topStatistics: {},
        }
    },
    created(){
        this.getstageDetailTopStatistics()
        this.getStageWork()
    },

    methods: {
        getStageWork(){
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.4)'
            });
            Http.stageWork(this.form).then((res) => {
                this.gridData = res.data.list
                this.total_number = res.data.total_number
                loading.close()
            });
        },
        getstageDetailTopStatistics(){
            var params = {
                level:this.form.level,
                grade:this.form.grade,
                trem:this.form.trem,
                type:this.form.type,
            }

            Http.stageDetailTopStatistics(params).then((res) => {
                this.topStatistics = res.data
            });
        },
        // 上一页

        prev(e){

            this.form.page = e
            this.getStageWork()
        },

        // 下一页
        next(e){

            this.form.page = e
            this.getStageWork()
        },

        // 点击页码
        changeNumber(e){

            this.form.page = e
            this.getStageWork()
        },

        // 前往指定页数
        changeSize(e){

            this.form.page = e
            this.getStageWork()
        },
        handleEdit(item){
            if(item.type == 'specialty'){
                this.$router.push({name:'SpecialtyDetail',query:{id:item.wid,type:item.z_type}});
            }else{
                this.$router.push({name:'ReadDetail',query:{id:item.wid}});
            }
            
        }
    }
}
</script>
<style scoped>
.stagedetail_page_top{
    display: flex;
    justify-content: space-between;
    gap: 20px;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
    
}
.top_label{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
}
.top_label_namebox{
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    background: #fff;
    padding: 20px;
    box-sizing: border-box;
    border-radius: 8px;
}
.top_label_namebox i{
    margin-top: 5px;
}
.lable_name{
    font-size: 18px;
    font-weight: 700;
    text-align: left;
}
.lable_title{
    font-size: 14px;
    text-align: left;
}
.stagedetail_statitsc{
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    margin-top: 25px;
}
.stagedetail_statitsc_item{
    display: flex;
    justify-content: space-between;
    box-shadow: 0 4px 20px rgba(64, 158, 255, 0.05);
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
    background: #fff;
}
.stagedetail_statitsc_item_content{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 20px;
}
.stagedetail_statitsc_item_content_icon{
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #D9ECFF;
    color: #409eff;
    font-size: 18px;
}
.stagedetail_statitsc_item_right{
    display: flex;
    align-items: center;
}
.stagedetail_statitsc_item_content .title{
    font-size: 14px;
    font-weight: 700;
}
.stagedetail_statitsc_item_content .number{
    font-size: 20px;
    font-weight: 700;
}
.stagedetail_work{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 25px;
}
.stagedetail_work_item{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 10px;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
}
.stagedetail_work_item .title{
    font-size: 15px;
    font-weight: 700;
}
.tag_box{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 15px;
}
.do_work{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    padding: 3px 9px;
    background: #D9ECFF;
    color: #409eff;
    border-radius: 5px;
    cursor: pointer;
    font-size: 14px;
}
.stagedetail_work_item_title_box{
    display: flex;
    justify-content: space-between;
    gap: 15px;
    width: 100%;
}
.stagedetail_work_item_title_box .score{
    font-size: 13px;
    color: #f56c6c;
}
.pagination_box{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 25px;
    background: #fff;
    padding: 20px;
    border-radius: 8px;
    box-sizing: border-box;
}
.statistics_number .unit{
    font-size: 14px;
    margin-left: 5px;
}
</style>
